import React, { useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./Contact.module.css";
import { FiMessageCircle, FiPhone, FiMapPin } from "react-icons/fi";
import FaqSection from "../../components/FaqSection/FaqSection";
import CertificationsSection from "../../components/CertificationsSection/CertificationsSection";
import { FAQ_DATA } from "../../constants/constants";
import logoIGI from "../../assets/images/logo_IGI.png";
import logoJBT from "../../assets/images/logo_JBT.png";
import logoVDB from "../../assets/images/logo_VDB.png";
import { useSendCntactusMutation } from "../../store/api/profileApi";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";
import { toast } from "sonner";
import BannerHeader from "../../components/BannerHeader/BannerHeader";

const Contact = () => {
  const [faqOpenIndex, setFaqOpenIndex] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [
    sendContctUs,
    { data: contactUsData, isLoading: contactRequestInProgress },
  ] = useSendCntactusMutation();
  const onSubmit = (data) => {
    sendContctUs(data).then((result) => {
      console.log({ result });
      toast.success(result.data.message);
      reset();
    });
  };

  const handleFaqToggle = (idx) => {
    setFaqOpenIndex(faqOpenIndex === idx ? null : idx);
  };

  return (
    <div className={styles.mainContainer}>
      <BannerHeader />
      <section className={"container"}>
        <div className={styles.contactUsHeader}>
          <h1 className="heading">Contact Us</h1>
          <p className="subheading">
            Have questions about pricing, plans, or how we can help? We'd love
            to chat!
          </p>
        </div>
        <div className={styles.contactGridWrapper}>
          <div className={styles.leftCol}>
            <div className={styles.contactCard}>
              <div className={styles.icon}>
                <FiMessageCircle aria-label="Chat to sales" />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.cardTitle}>Chat to sales</div>
                <div className={styles.cardDesc}>
                  Speak to our friendly team.
                </div>
                <a
                  className={styles.cardLink}
                  href="mailto:sales@untitledui.com"
                >
                  info@greenrockcreations.com
                </a>
              </div>
            </div>
            <div className={styles.contactCard}>
              <div className={styles.icon}>
                <FiPhone aria-label="Call us" />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.cardTitle}>Call us</div>
                <div className={styles.cardDesc}>Mon-Fri from 8am to 5pm.</div>
                <a className={styles.cardLink} href="tel:+15550000000">
                  +1 (212) 537-0290
                </a>
              </div>
            </div>
            <div className={styles.contactCard}>
              <div className={styles.icon}>
                <FiMapPin aria-label="Visit us" />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.cardTitle}>Visit us</div>
                <div className={styles.cardDesc}>
                  Come say hello at our office HQ.
                </div>
                <a
                  className={styles.cardLink}
                  href="https://goo.gl/maps/xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  580 - 5th Ave Suite LL-05A, New York, NY 10036
                </a>
              </div>
            </div>
          </div>
          <div className={styles.rightCol}>
            <form
              className={styles.form}
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel} htmlFor="name">
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  className={styles.input}
                  {...register("name", {
                    required: "Name is required",
                    minLength: {
                      value: 2,
                      message: "Name must be at least 2 characters",
                    },
                  })}
                  placeholder="Your Name"
                />
                {errors.name && (
                  <span className={styles.error}>{errors.name.message}</span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel} htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  className={styles.input}
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  })}
                  placeholder="you@example.com"
                />
                {errors.email && (
                  <span className={styles.error}>{errors.email.message}</span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel} htmlFor="contactNumber">
                  Contact Number
                </label>
                <input
                  id="contactNumber"
                  type="tel"
                  className={styles.input}
                  {...register("contactNumber", {
                    required: "Contact number is required",
                    pattern: {
                      value: /^\+?\d{7,15}$/,
                      message: "Invalid contact number",
                    },
                  })}
                  placeholder="e.g. +1234567890"
                />
                {errors.contactNumber && (
                  <span className={styles.error}>
                    {errors.contactNumber.message}
                  </span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel} htmlFor="companyName">
                  Company Name
                </label>
                <input
                  id="companyName"
                  type="text"
                  className={styles.input}
                  {...register("companyName", {
                    required: "Company name is required",
                  })}
                  placeholder="Your Company"
                />
                {errors.companyName && (
                  <span className={styles.error}>
                    {errors.companyName.message}
                  </span>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label className={styles.inputLabel} htmlFor="message">
                  Message
                </label>
                <textarea
                  id="message"
                  className={styles.input}
                  {...register("message", {
                    required: "Message is required",
                    minLength: {
                      value: 10,
                      message: "Message must be at least 10 characters",
                    },
                  })}
                  placeholder="How can we help you?"
                  rows={4}
                />
                {errors.message && (
                  <span className={styles.error}>{errors.message.message}</span>
                )}
              </div>
              <button className={styles.button} type="submit">
                Send Message{" "}
                {contactRequestInProgress && <InlineLoaderComponent />}
              </button>
            </form>
          </div>
        </div>
      </section>
      <FaqSection
        FAQ_DATA={FAQ_DATA}
        faqOpenIndex={faqOpenIndex}
        handleFaqToggle={handleFaqToggle}
      />
      <CertificationsSection
        logoIGI={logoIGI}
        logoJBT={logoJBT}
        logoVDB={logoVDB}
      />
    </div>
  );
};

export default Contact;
